export default __webpack_public_path__ + "static/media/icon-flag.0601f9e2.svg";